/**
 * Barre d'action de fiche ou de saisie : l'action principale de l'état
 * courant (une seule), une secondaire éventuelle, et ce qui manque ou ce qui
 * est en attente. Collée au-dessus de la barre du bas sur téléphone, à la
 * fin du contenu sur ordinateur.
 */
import type { ReactNode } from 'react';
import { ActionButton, type Action } from './action.js';

export function ActionBar(props: {
  primary: Action;
  secondary?: Action;
  /** Ce qui manque, ce qui est en file, ou un résumé (montant, durée). */
  status?: ReactNode;
  label?: string;
}): ReactNode {
  return (
    <div className="ui-action-bar" role="region" aria-label={props.label ?? 'Action principale'} data-ui="action-bar">
      {props.status ? <div className="ui-action-bar__status">{props.status}</div> : null}
      <div className="ui-action-bar__buttons">
        {props.secondary ? <ActionButton action={props.secondary} variant="secondary" /> : null}
        <ActionButton action={props.primary} large />
      </div>
    </div>
  );
}
